/* src/app/component/base/base.component.css */
/*# sourceMappingURL=base.component.css.map */
